module.exports = __webpack_public_path__ + "img/icons B_39.53fb7d9e.png";